import React from 'react';
import ReactDOM from 'react-dom';

const RenderModal: React.FC = ({ children }) =>
  ReactDOM.createPortal(<>{children}</>, document.getElementById('modal-render') as HTMLDivElement);

export default RenderModal;
